import { Directive, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./mathjax.service";
/**
 * A directive used to render mathml or latex.
 * Interface based on https://stackoverflow.com/a/55171047.
 */
export class MathJaxDirective {
    constructor(mathjaxService, el, renderer) {
        this.mathjaxService = mathjaxService;
        this.el = el;
        this.renderer = renderer;
        this._el = this.el.nativeElement;
        this.mheMathjaxRendered = new EventEmitter(false);
    }
    ngOnChanges() {
        // hide any pre-rendered junk
        this.renderer.setStyle(this._el, 'visibility', 'hidden');
        this.mathjaxService.render(this._el, this.mheMathjax).subscribe(() => {
            this.renderer.removeStyle(this._el, 'visibility');
            this.mheMathjaxRendered.emit(true);
        });
    }
}
MathJaxDirective.ɵfac = function MathJaxDirective_Factory(t) { return new (t || MathJaxDirective)(i0.ɵɵdirectiveInject(i1.MathJaxService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
MathJaxDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MathJaxDirective, selectors: [["", "mheMathjax", ""]], inputs: { mheMathjax: "mheMathjax" }, outputs: { mheMathjaxRendered: "mheMathjaxRendered" }, features: [i0.ɵɵNgOnChangesFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MathJaxDirective, [{
        type: Directive,
        args: [{
                selector: '[mheMathjax]',
            }]
    }], function () { return [{ type: i1.MathJaxService }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { mheMathjax: [{
            type: Input
        }], mheMathjaxRendered: [{
            type: Output
        }] }); })();
